import { Grid, Paper } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function InfoRow({ label, value }: { label: string; value: string }) {
  if (!value) return null;

  return (
    <MDBox
      display="grid"
      gridTemplateColumns="112px minmax(0, 1fr)"
      columnGap={1.25}
      alignItems="start"
      sx={{
        py: 0.35,
        borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
        "&:last-of-type": {
          borderBottom: "none",
          pb: 0,
        },
        "@media print": {
          gridTemplateColumns: "90px minmax(0, 1fr)",
          columnGap: 0.75,
          py: 0.2,
        },
      }}
    >
      <MDTypography
        variant="caption"
        fontWeight="bold"
        sx={{ lineHeight: 1.1, color: "#000" }}
      >
        {label}
      </MDTypography>
      <MDTypography
        variant="button"
        color="dark"
        sx={{
          display: "block",
          lineHeight: 1.2,
          wordBreak: "break-word",
          fontWeight: 500,
          textAlign: "right",
        }}
      >
        {value}
      </MDTypography>
    </MDBox>
  );
}

export default function OrganizationAndForemanDetails({
  organization,
  contact,
  foreman,
  estimator,
}: {
  organization: any;
  contact: any;
  foreman: any;
  estimator: any;
}) {
  return (
    <Grid item className="no-break">
      <MDBox height="100%" width="100%">
        <Paper
          sx={{
            p: 1.25,
            borderRadius: 1.5,
            backgroundColor: "#fff",
            border: "1px solid rgba(0, 0, 0, 0.08)",
            height: "100%",
            width: "100%",
          }}
        >
          <MDBox>
            <InfoRow
              label="Client Name"
              value={[contact?.title, contact?.firstName, contact?.lastName].filter(Boolean).join(" ")}
            />
            <InfoRow label="Client Phone" value={contact?.phone} />
            <InfoRow label="Foreman Name" value={foreman?.name} />
            <InfoRow label="Foreman Phone" value={foreman?.phone} />
            <InfoRow label="Estimator Name" value={estimator?.name} />
            <InfoRow label="Estimator Phone" value={estimator?.phone} />
          </MDBox>
        </Paper>
      </MDBox>
    </Grid>
  );
}
